import React from 'react';
import { connect } from 'react-redux';
import classes from './ReceiptsView.scss';
import ReceiptsList from './ReceiptsList';

class ReceiptsView extends React.Component {
    onSubmit = values => {};

    render = () => {
        return (
            <div className={classes.container}>
                <ReceiptsList />
                {this.props.children}
            </div>
        );
    };
}

const mapStateToProps = (state, props) => ({
    isFetching: state.isFetching,
});

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReceiptsView);
